import { IStyles } from '../../interfaces/styles';
import { colors } from '@constants/colors';

export const scrollStyles = {
  '&::-webkit-scrollbar': {
    height: '4px',
    width: '4px',
  },

  '&::-webkit-scrollbar-track': {
    backgroundColor: colors.silver,
    borderRadius: '10px',
  },

  '&::-webkit-scrollbar-thumb': {
    backgroundColor: colors.blue_second,
    borderRadius: '10px',
    boxShadow: 'unset',
  },
};

export const classes: IStyles = {
  root: {
    position: 'relative',
  },
  scrollContent: {
    position: 'absolute',
    height: '100%',
    inset: 0,
    overflowY: 'auto',
    scrollbarGutter: 'auto',
    paddingRight: 1,
    zIndex: 1,

    ...scrollStyles,
  },
};
